import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class LogOutModal extends Vue {
  logout() {
    this.$emit('logout');

    const modalElement = document.getElementById('go-modal-logout');

    if (modalElement) {
      modalElement.style.visibility = 'hidden';
    }

    const closeButton = document.getElementById('logoutButton');

    if (closeButton) {
      closeButton.click();
    }
  }
}
